import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Nav } from "react-bootstrap";
import { useFlags } from 'launchdarkly-react-client-sdk';
import OrderCard from "./OrderCard";
import { capitalizeObjEntries } from "../../util";
import { Loading } from "../state";
import RewardCard from "./RewardCard";
import { useHistory } from 'react-router-dom';

var AccountOrderTabs = function AccountOrderTabs(_ref) {
  var rewardsActivityFields = _ref.rewardsActivityFields,
      orders = _ref.orders,
      rewards = _ref.rewards,
      isLoading = _ref.isLoading,
      setCurrentOrder = _ref.setCurrentOrder,
      setShowOrderDetails = _ref.setShowOrderDetails,
      handleAreYouMissingPegCreditClick = _ref.handleAreYouMissingPegCreditClick;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var flags = useFlags();
  var useAccountRewardsTabFlag = flags['releaseRewardsActivityTabInAccountOrders'] ? flags['releaseRewardsActivityTabInAccountOrders'] : false;
  var history = useHistory();

  var onSelectHandler = function onSelectHandler(selectedKey) {
    setActive(selectedKey);
    window.localStorage.setItem('accountOrderTab', selectedKey);
    var urlParams = new URLSearchParams(window.location.search);
    var defaultNav = urlParams.get('nav');

    if (defaultNav && defaultNav !== '' && defaultNav !== selectedKey) {
      history.push("".concat(location.pathname));
    }
  };

  var checkActiveKey = function checkActiveKey() {
    var urlParams = new URLSearchParams(window.location.search);
    var defaultNav = urlParams.get('nav');

    if (defaultNav && defaultNav !== '') {
      if (defaultNav === 'rewardsActivity' || defaultNav === 'orderHistory') {
        setActive(defaultNav);
        return defaultNav;
      } else {
        return 'orderHistory';
      }
    } else {
      var selectedAccountOrderTab = window.localStorage.getItem('accountOrderTab');

      if (selectedAccountOrderTab) {
        setActive(selectedAccountOrderTab);
        return selectedAccountOrderTab;
      } else {
        setActive('orderHistory');
        return 'orderHistory';
      }
    }
  };

  useEffect(function () {
    checkActiveKey();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav, {
    defaultActiveKey: checkActiveKey,
    onSelect: onSelectHandler,
    className: "account-order-tabs-div"
  }, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    className: "account-order-tabs",
    eventKey: "orderHistory"
  }, "Order History")), useAccountRewardsTabFlag ? /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, {
    className: "account-order-tabs",
    eventKey: "rewardsActivity"
  }, "Rewards Activity")) : ""), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-card-list"
  }, active === "orderHistory" && !isLoading && orders.length ? orders.map(function (item) {
    return /*#__PURE__*/React.createElement(OrderCard, {
      key: item.id,
      order: item,
      viewDetailsActionCopy: "View Details",
      viewDetailsAction: function viewDetailsAction(e) {
        setCurrentOrder(item);
        setShowOrderDetails(true);
      }
    });
  }) : active === "rewardsActivity" && !isLoading && rewards.length ? rewards.map(function (item) {
    return /*#__PURE__*/React.createElement(RewardCard, {
      rewardsActivityFields: rewardsActivityFields,
      key: item.id,
      item: item
    });
  }) : /*#__PURE__*/React.createElement("div", null, !isLoading && active === "orderHistory" && /*#__PURE__*/React.createElement("p", null, "You don't have any past orders."), !isLoading && active === "rewardsActivity" && /*#__PURE__*/React.createElement("p", null, "Uh-Oh, something went wrong here. Try reloading the page. If the error persists, please try again later or feel free to reach out to Guest Relations if you need assistance."), isLoading && /*#__PURE__*/React.createElement(Loading, {
    isLoading: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit__link"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: handleAreYouMissingPegCreditClick
  }, "Are you Missing Peg Credit?")));
};

export default AccountOrderTabs;